import { render, staticRenderFns } from "./SdgPanel.vue?vue&type=template&id=23138cea&scoped=true&"
import script from "./SdgPanel.vue?vue&type=script&lang=js&"
export * from "./SdgPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23138cea",
  null
  
)

export default component.exports